import { createStore } from 'vuex'

export default createStore({
  state: {
    isCollapse: 0, 
    QRCode: '',
  },
  getters: {
    isCollapse: state => state.isCollapse,
  },
  mutations: {
    setIsCollapse(state, value) {
      state.isCollapse = value;
    },
    setQRCode(state, QRCode) {
      state.QRCode = QRCode;
    }
  },
  actions: {
    setIsCollapse({ commit }, value) {
      commit('setIsCollapse', value);
    }
  },
  modules: {
    
  }
})
